// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"22973060","264":"2a4ea7ec","477":"b1fde586","584":"26371418","658":"a9cb6061","775":"93c3b178","805":"bbed4e95","937":"4de7d57d","947":"f25ec52c"}[chunkId] + ".chunk.css";
};